// Print Helper Utility for better dot matrix printing
// Optimized for Epson LX-310

export const dotMatrixStyles = `
  <style>
    /* Optimized for Epson LX-310 Dot Matrix Printer */
    @page {
      size: 8.5in 11in;
      margin: 0.5in;
    }

    body {
      font-family: 'Courier New', Courier, monospace !important;
      font-size: 12pt;
      line-height: 1.4;
      color: #000 !important;
      margin: 0;
      padding: 20px;
    }

    * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    h1 {
      font-size: 24pt;
      font-weight: bold;
      margin: 10px 0;
    }

    h2 {
      font-size: 18pt;
      font-weight: bold;
      margin: 8px 0;
    }

    h3, h4, h5 {
      font-size: 14pt;
      font-weight: bold;
      margin: 6px 0;
    }

    p {
      margin: 4px 0;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      margin: 10px 0;
    }

    table th,
    table td {
      border: 1px solid #000;
      padding: 4px 6px;
      text-align: left;
      font-size: 11pt;
    }

    table th {
      font-weight: bold;
      background-color: #f0f0f0;
    }

    .text-right {
      text-align: right;
    }

    .text-center {
      text-align: center;
    }

    .font-weight-bold {
      font-weight: bold;
    }

    hr {
      border: none;
      border-top: 2px solid #000;
      margin: 10px 0;
    }

    /* Remove colors for monochrome printing */
    .text-success,
    .text-danger,
    .text-primary {
      color: #000 !important;
    }
  </style>
`;

export default {
  dotMatrixStyles,
};
